var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import AbstractEditable from './abstract';
var Select2Editable = /** @class */ (function (_super) {
    __extends(Select2Editable, _super);
    function Select2Editable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Select2Editable.prototype.render = function () {
        if (!this.hasOwnProperty('formattedValues')) {
            this.formattedValues = [];
        }
        var select = this.getElement().querySelector('.acs2');
        if (this.getObjectId()) {
            select.dataset.objectId = this.getObjectId();
        }
        if (this._args.select2.multiple) {
            select.setAttribute('multiple', true);
        }
        if (!this._args.showbuttons) {
            this.getElement().querySelector('.aceditable__form__controls').style.display = 'none';
        }
    };
    Select2Editable.prototype.close = function () {
        var select = this.getElement().querySelector('.acs2');
        jQuery(select).ac_select2('close');
        _super.prototype.close.call(this);
    };
    Select2Editable.prototype.valueToInput = function (value) {
        value = value ? value : [];
        value = Array.isArray(value) ? value : [value];
        var self = this;
        var select = self.getElement().querySelector('.acs2');
        var $select = jQuery(select);
        if (!self._args.ajax && value) {
            var selected = Array.isArray(value) ? value : [value];
            this._args.select2.data.map(function (d) {
                d.selected = false;
            });
            selected.forEach(function (value) {
                self.setSelectedOption(value);
            });
        }
        if (self._args.ajax && value) {
            value.forEach(function (record) {
                Object.keys(record).forEach(function (k) {
                    var option_element = document.createElement('option');
                    option_element.setAttribute('selected', true);
                    option_element.value = k;
                    option_element.text = record[k];
                    select.append(option_element);
                });
            });
        }
        $select.ac_select2(self._args.select2);
        if (!this._args.showbuttons) {
            $select.on('change', function () {
                self.save();
            });
        }
    };
    Select2Editable.prototype.setSelectedOption = function (value) {
        var data = this._args.select2.data;
        data.some(function (option) {
            if (option.value.toString() === value.toString()) {
                option.selected = true;
                return true;
            }
            return false;
        });
        return data;
    };
    Select2Editable.prototype.getValue = function () {
        var select = this.getElement().querySelector('select.acs2');
        if (this._args.select2.multiple) {
            return this.getSelectedValues();
        }
        return select.value;
    };
    Select2Editable.prototype.getSelectedValues = function () {
        var selected = this.getElement().querySelectorAll('select.acs2 option:checked');
        return Array.from(selected).map(function (option) { return option.value; });
    };
    Select2Editable.prototype.getTemplate = function () {
        return "<select class=\"acs2\"></select>";
    };
    Select2Editable.prototype._setDefaults = function () {
        this._defaults.type = 'select2';
        this._defaults.showbuttons = true;
    };
    return Select2Editable;
}(AbstractEditable));
export default Select2Editable;
